export const types = {
    Point: 1,
    Line: 2,
    Ellipse: 3,
    Rect: 4,
    Polyline: 5,
    Polygon: 6,
    Curve: 7,
    Path: 8
};
